import { Component, SanEvent } from 'san';

import { IOrganization } from 'src/models';
import organizationService from 'src/services/organization.service';
import OrganizationTree from '../OrganizationTree/OrganizationTree';
import { ICheckOrganizationCallback, IShowCheckOrganizationParams } from 'src/models';
import * as _ from 'lodash';
import { EOrgType } from 'src/enums';
import { ICancelCheckOrganizationCallback } from 'src/models/checkOrganization';


export default class CheckOrganization extends Component {
    constructor(options: any) {
        super(options);
    }

    static components = {
        'ui-organization-tree': OrganizationTree
    }

    messages = {
        'UI:organization-tree-changed': (arg: SanEvent<any, IOrganization>) => {
            this.data.set('checkedOrganization', arg.value);
        }
    }

    initData(): {
        checkedOrganization: IOrganization;
        isShow: boolean;
        callback: ICheckOrganizationCallback;
        cancelCallback: ICancelCheckOrganizationCallback;
        organizations: IOrganization[];
        q: string;
        organizationCount: number;
        type: EOrgType;
    } {
        return {
            checkedOrganization: null,
            isShow: false,
            callback: null,
            cancelCallback: null,
            organizations: [],
            q: '',
            organizationCount: 0,
            type: null
        };
    }

    inited() {
    }

    //#region owner调用
    show(params: IShowCheckOrganizationParams) {
        this.data.set('isShow', true)
        this.data.set('checkedOrganization', null);
        this.data.set('callback', params.callback);
        this.data.set('cancelCallback', params.cancelCallback);
        this.data.set('type', params.type);
        this.getLatelyOrganizations();
        // this.getOrganizationsCount();
    }
    //#endregion

    private getLatelyOrganizations() {
        organizationService.getLatelyOrganizations().then(organizations => {
            if (this.data.get('type')) {
                organizations = _.filter(organizations, { type: this.data.get('type')});
            }
            this.data.splice('organizations', [0, this.data.get('organizations').length, ...organizations]);
        });
    }

    // getOrganizationsCount() {
    //     organizationService.getOrganizationsCount().then(count => {
    //         this.data.set('count', count);
    //     });
    // }

    deleteCheckedItem() {
        this.data.set('checkedOrganization', null);
    }

    submit() {
        const checkedOrganization: IOrganization = this.data.get('checkedOrganization');
        organizationService.saveLatelyOrganization(checkedOrganization.org_number);
        const callback = this.data.get('callback');
        if (callback) {
            callback(checkedOrganization);
        }
        this.cancel();
    }

    cancel() {
        this.data.set('isShow', false);
        const cancelCallback = this.data.get('cancelCallback');
        if (cancelCallback) {
          cancelCallback();
        }
    }

    checkOrganization(organization: IOrganization) {
        this.data.set('checkedOrganization', organization);
    }

    getSearched() {
        return _.includes(this.data.get('checkedOrganization')?.org_name, this.data.get('q'));
    }

}